exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2455195120/src/src/app/shared/modules/page-header/page-header.component.scss
// module id = ../../../../../src/app/shared/modules/page-header/page-header.component.scss
// module chunks = main